import { render } from "./StackTemplates.vue?vue&type=template&id=63e0fdac"
import script from "./StackTemplates.vue?vue&type=script&lang=js"
export * from "./StackTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__